import {
    RESET_RATE_CALCULATOR_DATA,
    UPDATE_BASE_RATE_MILES,
    UPDATE_BASE_RATE_PER_MILE,
    UPDATE_BASE_RATE_ROW_TOTAL,
    UPDATE_FUEL_SURCHARGE_MILES,
    UPDATE_FUEL_SURCHARGE_RATE_PER_MILE,
    UPDATE_FUEL_SURCHARGE_ROW_TOTAL,
    UPDATE_EMPTY_MILES,
    UPDATE_EMPTY_MILES_RATE_PER_MILE,
    UPDATE_NUMBER_OF_STOPS,
    UPDATE_NUMBER_OF_STOPS_COST_PER_STOP,
    UPDATE_LOADING_FEE,
    UPDATE_UNLOADING_FEE,
    UPDATE_MARKUP_PERCENTAGE,
    UPDATE_FLAT_FEE,
    UPDATE_ADD_ON_TOTAL,
    UPDATE_NOTES,
    UPDATE_GRAND_TOTAL,
    UPDATE_ALL_IN_RATE_PER_MILE
} from '../../actions/marketInsights/rateCalculatorActions';

interface RateCalculator {
    baseRateMiles: string;
    baseRatePerMile: string;
    baseRateRowTotal: string;
    fuelSurchargeMiles: string;
    fuelSurchargeRatePerMile: string;
    fuelSurchargeRowTotal: string;
    emptyMiles: string;
    emptyMilesRatePerMile: string;
    numberOfStops: string;
    numberOfStopsCostPerStop: string;
    loadingFee: string;
    unloadingFee: string;
    markupPercentage: string;
    flatFee: string;
    addOnTotal: string;
    notes: string;
    grandTotal: string;
    allInRatePerMile: string;
}

const rateCalculatorInitialState: RateCalculator = {
    baseRateMiles: '0',
    baseRatePerMile: '0.00',
    baseRateRowTotal: '0.00',
    fuelSurchargeMiles: '0',
    fuelSurchargeRatePerMile: '0.00',
    fuelSurchargeRowTotal: '0.00',
    emptyMiles: '0',
    emptyMilesRatePerMile: '0.00',
    numberOfStops: '0',
    numberOfStopsCostPerStop: '0.00',
    loadingFee: '0.00',
    unloadingFee: '0.00',
    markupPercentage: '0.00',
    flatFee: '0.00',
    addOnTotal: '0.00',
    notes: '',
    grandTotal: '0.00',
    allInRatePerMile: '0.00'
};

const rateCalculatorReducer = (rateCalculator: RateCalculator = rateCalculatorInitialState, action: any): RateCalculator => {
    switch (action.type) {
        case RESET_RATE_CALCULATOR_DATA: {
            return rateCalculatorInitialState;
        }
        case UPDATE_BASE_RATE_MILES: {
            return {
                ...rateCalculator,
                baseRateMiles: action.payload
            };
        }
        case UPDATE_BASE_RATE_PER_MILE: {
            return {
                ...rateCalculator,
                baseRatePerMile: action.payload
            };
        }
        case UPDATE_BASE_RATE_ROW_TOTAL: {
            return {
                ...rateCalculator,
                baseRateRowTotal: action.payload
            };
        }
        case UPDATE_FUEL_SURCHARGE_MILES: {
            return {
                ...rateCalculator,
                fuelSurchargeMiles: action.payload
            };
        }
        case UPDATE_FUEL_SURCHARGE_RATE_PER_MILE: {
            return {
                ...rateCalculator,
                fuelSurchargeRatePerMile: action.payload
            };
        }
        case UPDATE_FUEL_SURCHARGE_ROW_TOTAL: {
            return {
                ...rateCalculator,
                fuelSurchargeRowTotal: action.payload
            };
        }
        case UPDATE_EMPTY_MILES: {
            return {
                ...rateCalculator,
                emptyMiles: action.payload
            };
        }
        case UPDATE_EMPTY_MILES_RATE_PER_MILE: {
            return {
                ...rateCalculator,
                emptyMilesRatePerMile: action.payload
            };
        }
        case UPDATE_NUMBER_OF_STOPS: {
            return {
                ...rateCalculator,
                numberOfStops: action.payload
            };
        }
        case UPDATE_NUMBER_OF_STOPS_COST_PER_STOP: {
            return {
                ...rateCalculator,
                numberOfStopsCostPerStop: action.payload
            };
        }
        case UPDATE_LOADING_FEE: {
            return {
                ...rateCalculator,
                loadingFee: action.payload
            };
        }
        case UPDATE_UNLOADING_FEE: {
            return {
                ...rateCalculator,
                unloadingFee: action.payload
            };
        }
        case UPDATE_MARKUP_PERCENTAGE: {
            return {
                ...rateCalculator,
                markupPercentage: action.payload
            };
        }
        case UPDATE_FLAT_FEE: {
            return {
                ...rateCalculator,
                flatFee: action.payload
            };
        }
        case UPDATE_ADD_ON_TOTAL: {
            return {
                ...rateCalculator,
                addOnTotal: action.payload
            };
        }
        case UPDATE_NOTES: {
            return {
                ...rateCalculator,
                notes: action.payload
            };
        }
        case UPDATE_GRAND_TOTAL: {
            return {
                ...rateCalculator,
                grandTotal: action.payload
            };
        }
        case UPDATE_ALL_IN_RATE_PER_MILE: {
            return {
                ...rateCalculator,
                allInRatePerMile: action.payload
            };
        }
        default:
            return rateCalculator;
    }
};

export default rateCalculatorReducer;
